import { SkillsLessonByTypeQuery$data } from '../graphQLOperations/__generated__/SkillsLessonByTypeQuery.graphql';
import { splitId } from './splitIdsFromBackEnd';
const includedLessonTypesIds = [2, 6, 7, 8, 9, 10, 11];

export interface Lesson {
  id?: string;
  link?: string | null;
  description?: string | null;
  name?: string | null;
  teacherOnly?: boolean | null;
  internal?: boolean;
  teacherLed?: boolean;
}
export interface LessonInfo {
  title: string | null | undefined;
  lessons: Lesson[];
}

export const getLessonsInfo = (lessonsQueryData?: SkillsLessonByTypeQuery$data | null): LessonInfo[] => {
  const sets: Record<
    string,
    {
      title: string | null | undefined;
      lessons: {
        id?: string;
        link?: string | null;
        description?: string | null;
        name?: string | null;
        teacherOnly?: boolean | null;
        internal?: boolean;
      }[];
    }
  > = {};

  lessonsQueryData?.lessonSkills?.nodes?.forEach(lesson => {
    if (includedLessonTypesIds.includes(Number(splitId(lesson.lesson?.type?.id as string)))) {
      const lessonPayload = {
        id: lesson.lesson?.id,
        link: lesson.lesson?.url,
        description: lesson.lesson?.summary,
        name: lesson.lesson?.name,
        teacherOnly: lesson.lesson?.teacherOnly,
        internal: lesson.lesson?.type?.id === 'LessonTypeNode:10',
        teacherLed: lesson.lesson?.type?.id === 'LessonTypeNode:11',
      };
      if (sets[lesson.lesson?.type?.id as string]) {
        sets[lesson.lesson?.type?.id as string]?.lessons.push(lessonPayload);
      } else {
        sets[lesson.lesson?.type?.id as string] = {
          title: lesson.lesson?.type?.name,
          lessons: [lessonPayload],
        };
      }
    }
  });

  //collaborative lessons should be at the end of the list, so we sort the sets accordingly
  const orderedSets = Object.values(sets).sort((a, b) => {
    if (a.title === 'Collaborative') return 1;
    if (b.title === 'Collaborative') return -1;
    return 0;
  });

  return orderedSets;
};
